import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType } from 'vue'

export const edittableColumnNumberProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
  // 千位分隔符
  thousandsSeparator: {
    type: Boolean,
    default: true,
  },
  // 百分比形式
  percentage: {
    type: Boolean,
    default: false,
  },
  // 是否可编辑
  editable: Boolean,
  cellEditable: Boolean,
  // input属性
  placeholder: String,
  min: Number,
  max: Number,
  step: Number,
  stepStrictly: Boolean,
  precision: Number,
  controls: Boolean,
  controlsPosition: String as PropType<'' | 'right'>,
})

export type EdittableColumnNumberProps = Partial<ExtractPropTypes<ReturnType<typeof edittableColumnNumberProps>>>

export default defineComponent({
  name: 'OEdittableColumnNumber',
  inheritAttrs: false,
  props: edittableColumnNumberProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
